import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import EnTranslation from "./en/language.json";
import ArTranslation from "./ar/language.json";

const resources = {
  en: {
    translation: EnTranslation,
  },
  ar: {
    translation: ArTranslation,
  },
};

i18next.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  supportedLngs: ["en", "ar"],
  lng: /^\/(en|ar)(\/|$)/.exec(window.location.pathname)?.[1] ||
    localStorage.getItem("lang") || navigator.language.split("-")[0],
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});
export default i18next;
